import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import liff from "lib/liff";
import { useUrlParams } from "hooks/useUrlParams";
import StyledButton from "default/components/StyledButton";
import { getGuidelinesUrl, getRequestFormUrl, howToUseDetailUrls } from "constants/links";

import OmagunLayout from "../components/OmagunLayout";
import OmagunTitle from "../components/OmagunTitle";

export default function HowToUse() {
  const { work, lng } = useUrlParams();
  const { t } = useTranslation([work, "common"]);
  const points = t(`${work}:HowToUseItems`, { returnObjects: true });

  return (
    <OmagunLayout page="HowToUse">
      <Box sx={{ px: 3.5, pb: 6 }}>
        <OmagunTitle>使い方</OmagunTitle>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {Array.isArray(points) && points.map((point) => (
            <Box key={point.point} sx={{ border: "1px solid #6c2025", background: "rgba(0,0,0,.68)", px: 2.5, py: 2 }}>
              <Typography sx={{ color: "#ff383c", fontSize: 12, letterSpacing: ".1em" }}>{point.point}</Typography>
              <Typography sx={{ mt: 0.7, fontFamily: '"TamanegiKaishoGeki", serif', fontSize: 19, whiteSpace: "pre-line" }}>{point.title}</Typography>
              <Typography sx={{ mt: 1.3, fontSize: 12, lineHeight: 1.8, whiteSpace: "pre-line" }}>{point.description}</Typography>
            </Box>
          ))}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center", mt: 5 }}>
          <StyledButton onClick={() => window.open((howToUseDetailUrls.omagun || howToUseDetailUrls.common)[lng] || howToUseDetailUrls.common.ja, "_blank")}>使い方詳細</StyledButton>
          <StyledButton onClick={() => window.open(getGuidelinesUrl(work, lng), "_blank")}>ご利用ガイドライン</StyledButton>
          <StyledButton onClick={() => liff.closeWindow()}>チャットに戻る</StyledButton>
          <StyledButton onClick={() => window.open(getRequestFormUrl(lng), "_blank")}>ご意見・ご要望</StyledButton>
        </Box>
      </Box>
    </OmagunLayout>
  );
}
